import React from 'react'
import Header from '../header/Header'
import './Main.css'
import Post from '../post/Post'
// import SideNav from "../sidenav/SideNav"
function Main() {
  const [data, setdata]=React.useState(1);
  return (
    <div className="main">
      {/* <SideNav /> */}
      <Header callback={setdata}/>
      <Post dummy={data}/>
    </div>
  )
}

export default Main